import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { 
  GithubOutlined, 
  LinkedinOutlined, 
  MailOutlined,
  HeartOutlined
} from '@ant-design/icons';
import './index.css';

const { Footer } = Layout;
const { Text, Link: AntLink } = Typography;

const AppFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Footer className="site-footer">
      <div className="footer-content">
        <div className="footer-sections">
          <div className="footer-section">
            <h3>关于博客</h3>
            <p>这是一个使用 React + Ant Design 构建的个人博客系统</p>
            <p>分享技术干货、生活感悟和学习笔记</p>
            <p>欢迎交流学习！</p>
          </div>
          
          <div className="footer-section">
            <h3>快速链接</h3>
            <ul className="footer-links">
              <li><AntLink href="/">首页</AntLink></li>
              <li><AntLink href="/archive">文章归档</AntLink></li>
              <li><AntLink href="/about">关于我</AntLink></li>
              <li><AntLink href="/write">写文章</AntLink></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>技术栈</h3>
            <p>React 19 + Ant Design 6.x</p>
            <p>React Router 7</p>
            <p>Webpack + Babel</p>
            <p>Mock 数据模拟</p>
          </div>
          
          <div className="footer-section">
            <h3>联系我</h3>
            <p><MailOutlined /> admin@blog.com</p>
            <div className="social-links">
              <AntLink href="https://github.com" target="_blank">
                <GithubOutlined className="social-icon" />
              </AntLink>
              <AntLink href="https://linkedin.com" target="_blank">
                <LinkedinOutlined className="social-icon" />
              </AntLink>
              <AntLink href="mailto:admin@blog.com">
                <MailOutlined className="social-icon" />
              </AntLink>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <Space direction="vertical" size="small">
            <Text type="secondary">
              © {currentYear} 好奇分享站 · Made with <HeartOutlined style={{ color: '#ff4d4f' }} /> by React & Ant Design
            </Text>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              课程设计项目 · 仅用于学习展示
            </Text>
          </Space>
        </div>
      </div>
    </Footer>
  );
};

export default AppFooter;